import React from 'react'
import PropTypes from 'prop-types'
import ExpandableSection from '../ExpandableSection'
import Collection from '../Collection'
import Thing from '../../utilities/Data/Thing'
import styles from './Social.icss'
import AddButton from '../AddButton'

class UserSocial extends React.Component {
	constructor(props) {
		super(props)
		this.handleUnfollow = this.handleUnfollow.bind(this)
		this.handleRemoveFollower = this.handleRemoveFollower.bind(this)
	}

	handleUnfollow(args) {
		this.props.userProfileFollowingRemove({ uid: args.uid, isFollowing: false })
	}

	handleRemoveFollower(args) {
		this.props.userProfileFollowerRemove({ uid: args.uid, isFollowing: false })
	}

	render() {
		const { countFollowers, countFollowing, countVerifiers, countVerified, isOwnProfile, userName, hasVerified, verify } = this.props
		return (
			<div className={styles.icss}>
				{this.props.userProfilePublicFollowing && (
					<ExpandableSection title={this.context.translate('{countFollowing} Following', { countFollowing })} defaultExpanded>
						<Collection
							items={this.props.userProfilePublicFollowing}
							itemTitle={u => u.realName}
							itemSubtitle={u => u.userName}
							itemImageContent={u => u.images}
							itemHref={Thing.href}
							itemImageCover
							contextMenuItems={isOwnProfile ? () => [
								{
									name: this.context.translate('Unfollow'),
									handler: this.handleUnfollow
								}
							] : []}
						/>
					</ExpandableSection>
				)}
				{this.props.userProfilePublicFollowers && (
					<ExpandableSection title={this.context.translate('{countFollowers} Followers', { countFollowers })} defaultExpanded>
						<Collection
							items={this.props.userProfilePublicFollowers}
							itemTitle={u => u.realName}
							itemSubtitle={u => u.userName}
							itemImageContent={u => u.images}
							itemHref={Thing.href}
							itemImageCover
							contextMenuItems={isOwnProfile ? () => [
								{
									name: this.context.translate('Remove follower'),
									handler: this.handleRemoveFollower
								}
							] : []}
						/>
					</ExpandableSection>
				)}
				{this.props.userProfilePublicVerifiers && (
					<ExpandableSection title={this.context.translate('{countVerifiers} Have Verified {userName}', { countVerifiers, userName })} defaultExpanded>
						<Collection
							items={this.props.userProfilePublicVerifiers}
							itemTitle={u => u.realName}
							itemSubtitle={u => u.userName}
							itemImageContent={u => u.images}
							itemHref={Thing.href}
							itemImageCover
						/>
					</ExpandableSection>
				)}
				{!isOwnProfile && !hasVerified && verify && (
					<div className={styles.verifyButtonSurround}>
						<AddButton variant="text" onClick={verify}>
							{this.context.translate('Verify {userName}', { userName })}
						</AddButton>
					</div>
				)}
				{this.props.userProfilePublicVerified && (
					<ExpandableSection title={this.context.translate('{countVerified} Verified by {userName}', { countVerified, userName })} defaultExpanded>
						<Collection
							items={this.props.userProfilePublicVerified}
							itemTitle={u => u.realName}
							itemSubtitle={u => u.userName}
							itemImageContent={u => u.images}
							itemHref={Thing.href}
							itemImageCover
						/>
					</ExpandableSection>
				)}
			</div>
		)
	}
}

UserSocial.contextTypes = {
	translate: PropTypes.func
}

UserSocial.propTypes = {
	isOwnProfile: PropTypes.bool,
	userName: PropTypes.string,
	hasVerified: PropTypes.bool,
	verify: PropTypes.func,
	userProfilePublicFollowing: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userProfilePublicFollowers: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userProfilePublicVerifiers: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	userProfilePublicVerified: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	countFollowers: PropTypes.number,
	countFollowing: PropTypes.number,
	countVerifiers: PropTypes.number,
	countVerified: PropTypes.number,
	userProfileFollowingRemove: PropTypes.func.isRequired,
	userProfileFollowerRemove: PropTypes.func.isRequired
}

UserSocial.defaultProps = {
	isOwnProfile: false,
	userName: '',
	userProfilePublicFollowing: undefined,
	userProfilePublicFollowers: undefined,
	userProfilePublicVerifiers: undefined,
	userProfilePublicVerified: undefined,
	countFollowers: 0,
	countFollowing: 0,
	countVerifiers: 0,
	countVerified: 0,
	hasVerified: undefined,
	verify: undefined
}

export default UserSocial



// WEBPACK FOOTER //
// ./src/components/User/Social.jsx